import ProtectorsDetails from '../organisms/Protectors/ProtectorsDetails';

const ProtectorDetail = () => {
  return <ProtectorsDetails />;
};

export default ProtectorDetail;

